import React, { useState, useEffect } from 'react';

import { Grid, Typography, TextField } from '@mui/material';
import { greyOutEmptyTextField } from '../../Helpers/helpers';

function JobCardNotes(props) {
  const setNotes = props.setNotes;

  const [notesData, setNotesData] = useState(props.notesInfo.notes);

  useEffect(() => {
    let data = props.notesInfo;
    setNotesData(data.notes);
  }, [props]);

  return (
    <>
      <Grid item xs={12} md={12} style={{ textAlign: 'left' }}>
        <Typography variant='h6' fontWeight='700'>
          Notes for Customer
        </Typography>
      </Grid>

      <Grid
        item
        border={'grey solid 1px'}
        xs={12}
        md={12}
        style={{
          textAlign: 'left',
          borderLeft: 'none',
          background: greyOutEmptyTextField(notesData)
        }}
      >
        <TextField
          size='small'
          fullWidth
          value={notesData}
          onChange={(value) => setNotes(value.target.value)}
        />
      </Grid>
    </>
  );
}

export default JobCardNotes;
